/** Represents an error result */
export type ErrorResult = { error: Error; isOK: false };

/** Represents a success result. */
export type SuccessResult<T> = { value: T | undefined; isOK: true };

/** Represents the validation result */
export type Result<T = undefined> = ErrorResult | SuccessResult<T>;

export const Result = {
  /** Creates a new failure result */
  fail(error: Error): ErrorResult {
    return { error: error, isOK: false };
  },
  /** Returns the success result */
  ok<T>(value?: T): SuccessResult<T> {
    return { isOK: true, value };
  },
};
